<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.payslipcondition') }} > {{ condition.name }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          v-if="!loading"
          class="action">
          <BaseActionDropdown
            v-if="hasRoleDelete"
            :icon="`fas fa-cog`"
            :text="$t('button.options')"
            :items="[
              {
                icon: 'fas fa-trash',
                iconClassName: 'text-danger',
                text: $t('button.delete'),
                textClassName: 'text-danger',
                value: 'delete',
              }
            ]"
            @onSelect="handleSelectOption"
          />
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <PayrollConditionForm
        :state="condition"
        :isSubmitted="isSubmitted"
        :disabled="disabled || !hasRoleEdit"
        :form.sync="form"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />

      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { PAYSLIP_CONDITION_TYPE } from '@/helpers/enum'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      query: {
        id: this.$route.query.id,
        name: this.$route.query.name,
      },
      modal: {
        show: false,
        loading: false,
      },
      form: null,
    }
  },

  computed: {
    ...mapState('payroll', {
      condition: 'conditionSingle',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
    }),
  },

  async created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.payroll.title'),
      current: {
        app_name: 'payroll',
        app_id: 14,
        module_id: 3,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 2, [{
      'name': this.query.name,
      'router': {
        'name': 'PaySlipConditionEdit',
        'query': {
          id: this.query.id,
          name: this.query.name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 2,
      submenuAtIdx: 2,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('payroll', {
      getConditionSingle: 'getConditionSingle',
      updateCondition: 'updateCondition',
      deleteCondition: 'deleteCondition',
    }),
    async fetchData () {
      this.loading = true
      await this.getConditionSingle(this.query.id)
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getData (form) {
      return {
        'type': form.type,
        'name': form.name,
        'is_increment': form.isIncrement,
        ...((() => {
          if (form.type !== PAYSLIP_CONDITION_TYPE.ADVANCED) {
            return null
          }
          return {
            'condition': {
              'variable': form.condition.variable,
              'operator': form.condition.operator,
              'value': form.condition.value,
              'if_true': form.condition.iftrue,
              'if_false': form.condition.iffalse,
            },
          }
        })()),
        'auto_apply_new_emp': form.autoApplyNewEmp,
      }
    },
    async handleSubmit (form = {}) {
      this.disabled = true
      this.isSubmitted = true
      const data = this.getData(form)
      const responseUpdate = await this.updateCondition({ id: this.query.id, data })
      if (responseUpdate.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: form.name }),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    handleSelectOption (value) {
      if (value === 'delete') {
        this.onOpenModal()
      }
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.deleteCondition(this.query.id)
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.condition.name }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'PaySlipConditionList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/payroll/condition/Edit.vue